module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "min-width": "500",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "scrollable": "",
      "hide-overlay": false,
      "persistent": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.resetContactImage()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Reset Image")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body pa-4"
  }, [_c('ContactDetails', {
    ref: "contactDetails",
    attrs: {
      "contact": _vm.contact
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.contact.meta.key) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteContact
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveContact($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelEdit($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1c506c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactEditor.vue
// module id = 2652
// module chunks = 1